import { useEffect } from 'react';
import DesktopLayout from '../../../layout/DesktopLayout';
import { useDesktopTopBar } from '../../../../context/DesktopLayoutContext';
import offersAccessImg from '../../../../assets/images/OffersAccessimg.jpeg';

/** Shown in place of any Offers screen when the signed-in role isn't permitted to manage offers. */
export default function OffersAccessRestricted() {
  const setTopBarProps = useDesktopTopBar();

  useEffect(() => {
    setTopBarProps({ title: 'Offers & Discounts', breadcrumbs: '' });
  }, [setTopBarProps]);

  return (
    <DesktopLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          height: '100%',
          boxSizing: 'border-box',
          padding: '24px 24px 120px',
          background: 'var(--surface, #FFFFFF)',
        }}
      >
        <img
          src={offersAccessImg}
          alt=""
          style={{ width:360, maxWidth: '80%', marginBottom: -25}}
        />
        <h2
          style={{
            fontSize: 'var(--fs-h2, 20px)',
            fontFamily: 'var(--font-primary)',
            color: 'var(--t1)',
            margin: 0,
            marginBottom: 8,
            fontWeight:500
          }}
        >
          Access Restricted
        </h2>
        <p
          style={{
            fontSize: 'var(--fs-body, 16px)',
            fontFamily: 'var(--font-primary)',
            // color: 'var(--t3, #9CA3B8)',
              color: 'var(--t1)',
            margin: 0,
            fontWeight:300
          }}
        >
          You don't have permission to access this page.
        </p>
      </div>
    </DesktopLayout>
  );
}
